import { DraftResponse } from '../../../shared/types';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export class DraftRequestError extends Error {
  constructor(message: string, public status: number) {
    super(message);
    this.name = 'DraftRequestError';
  }
}

async function requestDraft(path: string, init?: RequestInit): Promise<DraftResponse> {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...init,
    headers: init?.body
      ? { 'Content-Type': 'application/json', ...(init.headers || {}) }
      : init?.headers,
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new DraftRequestError(payload.message || payload.error || `HTTP error! status: ${response.status}`, response.status);
  }
  return payload as DraftResponse;
}

export class DraftService {
  static fetchCurrentDraft(): Promise<DraftResponse> {
    return requestDraft('/draft/current', { method: 'GET' });
  }

  static makePick(team: string, expectedPickNumber: number): Promise<DraftResponse> {
    return requestDraft('/draft/picks', {
      method: 'POST',
      body: JSON.stringify({ team, expectedPickNumber }),
    });
  }

  static undoLatestPick(expectedPickNumber: number): Promise<DraftResponse> {
    return requestDraft('/draft/picks/latest', {
      method: 'DELETE',
      body: JSON.stringify({ expectedPickNumber }),
    });
  }
}
